import { memo } from "react";
import { Form, Select, Modal } from "antd";
import { MILESTONE_STATUS_OPTIONS } from "../tracker.constants";
import "../../../styles/trackon.css"



function MilestoneStatusModalComponent({
  open,
  selectedStatus,
  onStatusChange,
  onOk,
  onCancel,
}) {
  return (
    <Modal className="trackon-root" title="Update Milestone Status" open={open} onOk={onOk} onCancel={onCancel} okText="Update" width={560}>
      <Form layout="vertical" style={{ marginTop: 8 }}>
        <Form.Item label="Milestone Status" required>
          <Select
            value={selectedStatus}
            onChange={onStatusChange}
            options={MILESTONE_STATUS_OPTIONS}
            placeholder="Select status"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export const MilestoneStatusModal = memo(MilestoneStatusModalComponent);
